import variableScript from "./variableScript" 
export default class globalScript extends variableScript{
    constructor(system){
        super(system);
    }
    
    //关闭窗口
    Exit(val) {
        if(val == 0){
            opener=null;//判断没有输入框
            open('','_self');
            close();
        }
    }
    
    PrintAll(viewName){
        this.system.$.printView(viewName,html2);
    }

    //注册对象
    returnObjFromStr(str){
        var exeStr = "if(typeof(" + str + ")!= 'undefined') " +"return " + str + ";"
                        + "else " + "return null";
        return ( AsyncFunction(exeStr)());
    }

    registerUnitObj(str, obj){
        var exeStr = "if(obj) " + str + " = obj;"
                        +"else " + str + " = {}; return " + str + ";";
        return (AsyncFunction('obj', exeStr)(obj));
    }

    registerObj(str,obj){
        var splitArray = str.split(".");
        if(splitArray.length == 0) return null;
        var regObjStr = "";

        dojo.forEach(splitArray,function(curStr){
            if(regObjStr != ""){
                regObjStr += "." + curStr;
            }else{
                regObjStr += curStr;
            }

            if(regObjStr === str){
                registerUnitObj(regObjStr,obj); //最后一级注册
            }else if(regObjStr !== "window"&&returnObjFromStr(regObjStr) === null){
                registerUnitObj(regObjStr); //分级注册
            }
        });

        var exeStr = "return " + regObjStr + ";";
        return (AsyncFunction(exeStr)());
    }

    fcFunction(){
        var tempStr = arguments[arguments.length-1];
        tempStr = "try{" + tempStr + "}catch(e){console.log(e.stack);}";
        arguments[arguments.length-1] = tempStr;
        switch(arguments.length){
            case 1 :  return AsyncFunction(arguments[0]);
            case 2 :  return AsyncFunction(arguments[0],arguments[1]);
            case 3 :  return AsyncFunction(arguments[0],arguments[1],arguments[2]);
            case 4 :  return AsyncFunction(arguments[0],arguments[1],arguments[2],arguments[3]);
            case 5 :  return AsyncFunction(arguments[0],arguments[1],arguments[2],arguments[3],arguments[4]);
            case 6 :  return AsyncFunction(arguments[0],arguments[1],arguments[2],arguments[3],arguments[4],arguments[5]);
            case 7 :  return AsyncFunction(arguments[0],arguments[1],arguments[2],arguments[3],arguments[4],arguments[5],arguments[6]);
            default:
                return new Function("return null");
        }
    }

    //全局的右键菜单
    ContextMenuAll(key){
        return this.system.$.contextMenu(key);
    }

    windowFocus(){
        return 1;
    }

    fcSetTimeout(callback) {
        var currTime = new Date().getTime();
        var timeToCall = Math.max(0, 16 - (currTime - fcLastTime));
        var id = setTimeout(function () {
            callback(currTime + timeToCall);
        }, timeToCall);
        fcLastTime = currTime + timeToCall;
        return id;
    };

    fcRect(){
        return{
            initRect:function(pLeft,pTop,pBottom,pRight){
                this.left = pLeft;
            },
            left:0,
            top:0,
            bottom:0,
            right:0,
            width:0,
            height:0
        }
    };

    fcPoint(){
        return{
            x:0,
            y:0,
            r:0
        }
    }

    fcAdjustAng(ang){
        while(ang>2*FC_PI){
            ang = ang - 2*FC_PI;
        }

        while(ang<0){
            ang = ang + 2*FC_PI;
        }

        return ang;
    }

    fcGetStartEndPt(startPt, endPt, inputRect, inputAng){

        startPt.x = inputRect.left;
        startPt.y = inputRect.top;

        //var tempPt = {
        //    x:0,
        //    y:0
        //};
            var centerPt = {
                x: parseInt(inputRect.left + inputRect.width / 2),
                y: parseInt(inputRect.top + inputRect.height / 2)
            }

            var tempAng1 = inputAng;
            while(tempAng1>(FC_PI/2) || tempAng1<0){
                    if(tempAng1>FC_PI/2){
                        tempAng1 = Math.abs(tempAng1 - FC_PI);
                    }else{
                        tempAng1 = tempAng1 + FC_PI;
                    }
            }

            tempAng2 = Math.atan(inputRect.height/inputRect.width);

            tempAng3 = Math.abs(tempAng1 - tempAng2);

            var radius = parseInt(Math.sqrt(inputRect.width*inputRect.width + inputRect.height*inputRect.height)*Math.cos(tempAng3)/2);
            var colorChangeAng = inputAng;//计算渐变方向
            colorChangeAng = fcAdjustAng(colorChangeAng);//角度调整到 0到2*FC_PI

            startPt.x = -radius * Math.cos(colorChangeAng) + centerPt.x;
            startPt.y = -radius * Math.sin(colorChangeAng) + centerPt.y;

            endPt.x = radius * Math.cos(colorChangeAng) + centerPt.x;
            endPt.y = radius * Math.sin(colorChangeAng) + centerPt.y;
    }

    fcGetStartEndPathPt(startPt, endPt, inputRect){
        var centerPt = {
            x: parseInt(inputRect.left + inputRect.width / 2),
            y: parseInt(inputRect.top + inputRect.height / 2)
        }
        startPt.x =  centerPt.x;
        startPt.y =  centerPt.y;
        startPt.r = 0;

        endPt.x =  centerPt.x;
        endPt.y =  centerPt.y;
        //endPt.r = inputRect.width > inputRect.height?inputRect.height/2:inputRect.width/2;
        endPt.r = Math.sqrt(inputRect.width * inputRect.width + inputRect.height * inputRect.height) / 2;
        //inputRect.width > inputRect.height?inputRect.height/2:inputRect.width/2;
    }

    //获取元素的纵坐标
    getTop(e){
        var offset;
        if(e == document.body){
            offset=e.offsetTop;
        }else{
            offset=e.offsetTop - e.scrollTop;
        }
        //var offset=e.offsetTop - e.scrollTop;
        if(e.offsetParent!=null) offset+=getTop(e.offsetParent);
        return offset;
    }
    //获取元素的横坐标
    getLeft(e){
        var offset;
        if(e == document.body){
            offset=e.offsetLeft;
        }else{
            offset=e.offsetLeft - e.scrollLeft;
        }
        if(e.offsetParent!=null) offset+=getLeft(e.offsetParent);
        return offset;
    }
    //获取事件绝对位置
    mouseX(evt) {
        if (evt.pageX) return evt.pageX;
        else if (evt.clientX)
            return evt.clientX + (document.documentElement.scrollLeft ?
                    document.documentElement.scrollLeft :
                    document.body.scrollLeft);
        else return null;
    }

    mouseY(evt) {
        if (evt.pageY) return evt.pageY;
        else if (evt.clientY)
            return evt.clientY + (document.documentElement.scrollTop ?
                    document.documentElement.scrollTop :
                    document.body.scrollTop);
        else return null;
    }
    //获取线的格式
    lineStyle(type){
        var size = "";
        switch (type){
            case 0 :
                size = [0,0];
                break;
            case 1 :
                size = [18,8];
                break;
            case 2 :
                size = [3.5,3.5];
                break;
            case 3 :
                size = [8,3.5,3.5];
                break;
            case 4 :
                size = [3,3,6];
                break;
            default :
                size = [0,0];
                break;
        }
        return size;
    }

    deepCopy(source){
        var result={};
        for (var key in source) {
            result[key] = typeof source[key]=='object'?deepCopy(source[key]):source[key];
        }
        return result;
    }

    deepcopy1(p,c){
        var c = c || {};
        for (var i in p) {
            if (typeof p[i] === 'object') {
                //console.log(p[i])
                if(p[i] && p[i].constructor && p[i].constructor === Array){
                    c[i] = [];
                }else{
                    c[i] = {};
                }
                deepcopy1(p[i], c[i]);
            } else {
                c[i] = p[i];
            }
        }
        return c;
    }

    showAllTags(){
        for(var p in getDataArr){
            console.log(p);
        }
    }

    //模拟异步编程效果
    customPromise(func){
        
    }
}




// WEBPACK FOOTER //
// ./src/js/script/js/globalScript.js